var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { query } from 'lit/decorators.js';
import { html, css } from 'lit';
import { customElement, PICAction, PIC, PICBase, fetchApiData, } from '../Internals';
let PICDocs = class PICDocs extends PICBase {
    get files_() {
        if (this.fileFld && this.fileFld.files)
            return this.fileFld.files;
    }
    constructor() {
        super();
        this.canDrop = false;
        this.multiple_ = false;
        this.fileTypes_ = '';
        this.state_ = '0 files selected.';
        this.buttonWidth = 142;
        this.viewData = false;
    }
    static get styles() {
        const defaultStyle = css `
    :host{
        --returnTypeColor: #795e26;
        --paramColor: #001080;
        --paramTypeColor: #887f99;
        --topHdrColor: #2f54a7;
        --hdrBGColor: #d0cece;
        --pic-fontColor: 
                linear-gradient(to right, var(--pic-onSurfaceMediumColor), var(--pic-onSurfaceMediumColor)),
                linear-gradient(to right, var(--pic-backgroundColor), var(--pic-backgroundColor));
    }
    table, td, th {
        border: 1px solid black;
        /* line-height: 0; */
        /* padding: 0px 4px 0px 4px; */
    }    
    .table{
        border-collapse: collapse;
    }
    .hdr, .hdrSub{
        background-color: var(--hdrBGColor);
    }
    .topHdr{
        font-size: x-large;
        color: var(--topHdrColor);
    }   
    .hdr{
        font-size: large;
    }
    .hdrSub{
        font-size: medium;
    }
    .cell{

    }
    .center{
        text-align: center;
    }
    .param{
        color: var(--paramColor);
    }
    .paramType{
        color: var(--paramTypeColor);
    }
    .returnType{
        color: var(--returnTypeColor);
    }

    .inner-input {
            width: 100%;
            box-sizing: border-box;
            font-family: monospace;
        }
        .button {
            border-radius: 0;
            -webkit-appearance: none;
            text-align: center;
            font-size: 1em;
            width: 100%;
            background: rgba(0, 0, 0, .63);
            background: var(--buttonColor);
            border: 1px solid black;
            color: white;
            height: 30px;
            cursor: pointer;
        }
        .pic-subtitle1 {
            color: var(--pic-onSurfaceMediumColor);
        }
        .pic-subtitle2 {
            color: var(--pic-onSurfaceDisabledColor);
        }
        .upload-container {
            padding: 28px;
            width: 370px;
            background-color: var(--pic-surfaceColor);
            /* border: 2px dashed rgba(0, 0, 0, 0.12); */
            display: flex;
            flex-direction: column;
            align-items: center;
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='rgba(0, 0, 0, 0.12)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
        }
        .upload-icon::after {
            content: '\u{F0A4D}';
            font-family: "Material Design Icons";
            width: 40px;
            height: 16px;
            font-style: normal;
            font-weight: 400;
            font-size: 40px;
            line-height: 16px;
            color: var(--pic-onSurfaceDisabledColor);
        }
        .upload-container.extravisible {
            background-color: var(--pic-backgroundColor);
            stroke: var(--pic-primaryColor);
        }
        .upload-container.canDrop {
            background-color: var(--pic-backgroundColor);
            stroke: var(--pic-statusOkColor);
        }
        .upload-buttons {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            column-gap: 24px;
        }
        .inliner{
            display: inline-flex;
        }
        .outer {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.fileClickAction = new PICAction();
        this.uploadClickAction = new PICAction();
        this.readClickAction = new PICAction();
        // PIC.getInstance.addEventListener('drop', ((e: Event) => this.preventDefaults(e)).bind(this));
        // PIC.getInstance.events.addUploadField(this);
    }
    firstUpdated() {
        this.fileClickAction.type_ = 'internal';
        this.fileClickAction.eventFnc = (() => { this.fileFld.click(); }).bind(this);
        this.uploadClickAction.type_ = 'internal';
        this.uploadClickAction.eventFnc = this.handleUpload.bind(this);
        this.readClickAction.type_ = 'internal';
        this.readClickAction.eventFnc = this.getFromApi.bind(this);
    }
    getFromApi() {
        let options = {
            // sessionId: PIC.sessionCode,
            systemId: PIC.systemId,
            postBody: { fileName: this.filePathFld.submitValue, readFolder: false },
        };
        fetchApiData('/test/picdocs', options).then((data) => {
            if (data && data.docAnnotation) {
                this.data = data.docAnnotation;
                this.viewData = true;
                this.requestUpdate();
            }
        }).catch(err => console.log(err));
    }
    ;
    handleUpload() {
        if (this.files_)
            for (var i = 0; i < this.files_.length; i++) {
                this.readFile(this.files_[i]);
            }
        ;
        this.requestUpdate();
    }
    ;
    parseFile(iFileTxt) {
        if (iFileTxt == null) {
            let test = [{
                    functionStr: 'getValue char(FldId as char)',
                    hdr: 'getValue',
                    returnType: 'char',
                    functionDescription: 'Function to retrieve data from comminfo.',
                    inputParams: [{ id: 'FldId', type: 'char', description: 'Is the id of the value' }],
                    returnParams: [{ type: 'char', description: 'If the field id is present in comminfo string, this will return the first in the data string' }]
                }];
            this.data = test;
        }
        else if (typeof iFileTxt == 'string') {
            let docAnnotationRegEx = /(\/\*\*(\n|\r)+)(\*.*(\n|\r)+)(\*.\@param.*(\n|\r)+)+(\*.\@returns.*(\n|\r)+)(\*\/(\n|\r)+)(.*|(\n|\r)+)(function.*)/gmi;
            let functions = iFileTxt.match(docAnnotationRegEx);
            console.log('done parsing', functions);
        }
    }
    readFile(iFile) {
        let fRead = new FileReader();
        console.log('reading file', iFile);
        fRead.readAsText(iFile);
        fRead.onloadend = () => this.parseFile(fRead.result);
    }
    renderFunctionInputParams(functionParams) {
        let numOfParams = functionParams === null || functionParams === void 0 ? void 0 : functionParams.length;
        return html `${functionParams === null || functionParams === void 0 ? void 0 : functionParams.map((fp, idx) => html `
            <span class="cell param">${fp.id}</span>
            <span class="cell"> as </span>
            <span class="cell paramType">${fp.type}</span>${numOfParams && numOfParams != idx + 1 ? ', ' : ''}
    `)}
    `;
    }
    renderReturnParams(returnParams) {
        return html `${returnParams === null || returnParams === void 0 ? void 0 : returnParams.map(rp => html `
                <tr>
                    <td class="cell">
                        <p><span>${rp.type}</span></p>
                    </td>
                    <td class="cell" colspan="2">
                        <p><span>${rp.description}</span></p>
                    </td>
                </tr>
            `)}
            `;
    }
    renderFunctionParamDescription(functionParams) {
        return html `${functionParams === null || functionParams === void 0 ? void 0 : functionParams.map(fp => html `
            <tr>
                <td class="cell">
                  <p><span>${fp.id}</span></p>
                </td>
                <td class="cell">
                  <p><span>${fp.type}</span></p>
                </td>
                <td class="cell" colspan="2">
                  <p><span>${fp.description}</span></p>
                </td>
            </tr>
    `)}
    `;
    }
    renderDoc(iData) {
        return html `
      <body>
        <div>
          <div class="topHdr"><span>${iData.hdr}</span></div>
          <table class="table">
            <tbody>
              <tr>
                <td class="cell" colspan="3">
                  <p>
                    <span>${iData.hdr} </span>
                    <span class="returnType">${iData.returnType}</span>
                    <span>(</span>
                    ${this.renderFunctionInputParams(iData.inputParams)}
                    <span>)</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td class="" colspan="3">
                  <p><span>${iData.functionDescription}</span></p>
                </td>
              </tr>
              <tr>
                <td class="hdr" colspan="3">
                  <p><b><span>Parameters</span></b></p>
                </td>
              </tr>
              <tr>
                <td class="hdrSub">
                  <p><b><span>Name</span></b></p>
                </td>
                <td class="hdrSub" style="width: 3rem">
                  <p><b><span>Type</span></b></p>
                </td>
                <td class="hdrSub">
                  <p><b><span>Description</span></b>
                  </p>
                </td>
              </tr>
              ${this.renderFunctionParamDescription(iData.inputParams)}
              <tr>
                <td class="hdr" colspan="3">
                  <p><b><span>Returns</span></b></p>
                </td>
              </tr>
              <tr>
                <td class="hdrSub">
                  <p><b><span>Type</span></b></p>
                </td>
                <td class="hdrSub" colspan="2">
                  <p><b><span>Description</span></b>
                  </p>
                </td>
              </tr>
              ${this.renderReturnParams(iData.returnParams)}
            </tbody>
          </table>
        </div>
      </body>
    `;
    }
    getContainerClass() {
        return {
            'upload-container': true,
            'pic-subtitle1': true,
            'canDrop': this.canDrop,
            // 'extravisible': this.isExtraVisible_
        };
    }
    dropHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        this.canDrop = false;
        PIC.getInstance.events.toggleUploadFields('Files', undefined, false);
        if (e.dataTransfer) {
            this.fileFld.files = e.dataTransfer.files;
            this.fileFld.dispatchEvent(new Event('change'));
        }
    }
    handleDragLeave() {
        this.preventDefaults;
        this.canDrop = false;
        this.requestUpdate();
    }
    handleDragEO() {
        this.preventDefaults;
        this.canDrop = true;
        this.requestUpdate();
    }
    renderDropable() {
        this.requestUpdate();
    }
    renderUploadButton() {
        if (this.files_ && this.files_.length > 0)
            return html `
            <pic-button .action=${this.uploadClickAction} type='button' etype='contained' density='low' width=${this.buttonWidth} label='Read ${'(' + this.files_.length + ')'}'></pic-button>
            <!-- <div class='removeall'>Remove all</div> -->
            `;
    }
    preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    fileLstChanged(e) {
        if (this.files_) {
            for (let file of this.files_) {
                console.log(file);
            }
            this.state_ = this.files_.length + ' file' + (this.files_.length != 1 ? 's' : '') + ' selected.';
        }
        this.requestUpdate();
    }
    render() {
        var _a;
        if (this.viewData)
            return html `${(_a = this.data) === null || _a === void 0 ? void 0 : _a.map(data => this.renderDoc(data))}`;
        else
            return html `
        ${this.renderCSS(true)}
        <div class="outer">
        <div class=${classMap(this.getContainerClass())}
            @drop=${this.dropHandler}
            @dragenter=${this.handleDragEO}
            @dragleave=${this.handleDragLeave}
            @dragover=${this.handleDragEO}
            >
            <input 
                type="file"
                ?multiple=${this.multiple_}
                id="fileInput"
                name="fileInput"
                style="display:none;"
                accept=${this.fileTypes_}
                @change=${this.fileLstChanged}
                >
                <div class='upload-icon'></div>
                <p>Drag and drop File to read</p>
                <p class='pic-subtitle2'>or</p>
                <div class='upload-buttons'>
                    <pic-button .action=${this.fileClickAction} type='button' etype='outlined' density='low' width=${this.buttonWidth} label='Select files'></pic-button>
                    ${this.renderUploadButton()}
                </div>
        </div>
        <div class="inliner">
            <pic-text id="filePathFld" width=280 label="Input Filepath" etype="default" density="low" value="xml/incl/xmlprog2.i"></pic-text>
            <pic-button .action=${this.readClickAction} type='button' etype='outlined' density='low' width=${this.buttonWidth} label='Read'></pic-button>
        </div>
        </div>
        `;
    }
};
__decorate([
    query('#fileInput')
], PICDocs.prototype, "fileFld", void 0);
__decorate([
    query('#filePathFld')
], PICDocs.prototype, "filePathFld", void 0);
PICDocs = __decorate([
    customElement('pic-docs')
], PICDocs);
export { PICDocs };
//# sourceMappingURL=PICDocs.js.map